import { useEffect, useState } from 'react'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import {
  Card,
  CardBody,
  CardHeader,
  Modal,
  ModalBody,
  ModalHeader,
} from 'reactstrap'
import {
  getJobs,
  getSystemSetup,
  setAllJobApplicationsAndJobs,
  updateJobApplication,
} from 'store/Recruitment/actions'
import ApplicationDetails from '../JobDetails/ApplicationDetails/ApplicationDetails'
import ApplicationsFilters from './ApplicationsFilters'
import CreateInterviewModal from '../JobDetails/ApplicationDetails/CreateInterviewModal'
import AxiosInstance from 'utils/AxiosInstance'
import AddToJobOnboard from '../JobDetails/ApplicationDetails/AddToJobOnboard'
import { setAreYouSureModalData } from 'store/Recruitment/actions'

function JobApplications() {
  const dispatch = useDispatch()
  const {
    allApplications,
    filterJob,
    filterJobStage,
    filterEndDate,
    filterStartDate,
  } = useSelector((store) => store.recruitment)

  const [applications, setApplications] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [showCreateInterviewModal, setShowCreateInterviewModal] =
    useState(false)

  const [showOnboardingModal, setShowOnboardingModal] = useState(false)

  const history = useHistory()

  useEffect(() => {
    dispatch(getJobs())
    dispatch(setAllJobApplicationsAndJobs())
  }, [dispatch])

  const [jobStages, setJobStages] = useState([])

  useEffect(() => {
    AxiosInstance.get(`/recruitment/setup/job_stage`).then((data) =>
      setJobStages(
        data?.map((el) => {
          return {
            name: el?.value,
            id: el?.id,
            interview_stage: el?.interview_stage,
            hired_stage: el?.hired_stage,
          }
        })
      )
    )
  }, [])

  const interViewStage = jobStages?.find((el) => el?.interview_stage === 'true')

  const hiredStage = jobStages?.find((el) => el?.hired_stage === 'true')

  const onDragEnd = (result) => {
    const { source, destination, draggableId } = result

    if (!destination || source.droppableId === destination.droppableId) return

    const updateStage = () => {
      dispatch(
        updateJobApplication(draggableId, {
          job_stage: destination.droppableId,
        })
      )

      const updatedApplications = [...allApplications].map((application) =>
        application.id.toString() === draggableId
          ? { ...application, job_stage: destination.droppableId }
          : application
      )

      dispatch({
        type: 'SET_ALL_APPLICATIONS',
        payload: updatedApplications,
      })
    }

    if (destination?.droppableId === interViewStage?.id) {
      history.push(`/job-application?application=${draggableId}`)
      setShowCreateInterviewModal(true)
      return
    }

    if (destination?.droppableId === hiredStage?.id) {
      history.push(`/job-application?application=${draggableId}`)
      setShowOnboardingModal(true)
      return
    }

    if (
      source?.droppableId === interViewStage?.id &&
      destination?.droppableId !== interViewStage?.id
    ) {
      dispatch(
        setAreYouSureModalData({
          show: true,
          text: 'All scheduled interviews with this candidate will be removed!',
          customFn: () => updateStage(),
        })
      )
      return
    }

    if (
      source?.droppableId === hiredStage?.id &&
      destination?.droppableId !== hiredStage?.id
    ) {
      dispatch(
        setAreYouSureModalData({
          show: true,
          text: 'Candidate will be removed from job onboarding',
          customFn: () => updateStage(),
        })
      )
      return
    }

    updateStage()
  }

  useEffect(() => {
    setApplications(
      allApplications
        ?.filter((el) =>
          filterJob ? el?.job_id === filterJob?.option?.id : true
        )
        ?.filter((el) =>
          filterJobStage ? el?.job_stage === filterJobStage?.option?.id : true
        )
        ?.filter((el) =>
          filterStartDate ? el?.applied_at >= filterStartDate : true
        )
        ?.filter((el) =>
          filterEndDate ? el?.applied_at <= filterEndDate : true
        )
    )
  }, [
    allApplications,
    filterJob,
    filterJobStage,
    filterStartDate,
    filterEndDate,
  ])

  return (
    <>
      <ApplicationsFilters />
      <DragDropContext onDragEnd={onDragEnd}>
        <div
          className='d-flex align-items-start px-1'
          style={{ gap: '2rem', overflowX: 'auto' }}
        >
          {jobStages?.map((jobStage) => (
            <Droppable droppableId={jobStage?.id.toString()} key={jobStage?.id}>
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  style={{ width: '380px', minWidth: '380px' }}
                >
                  <Card>
                    <CardHeader className='title d-flex align-items-center justify-content-between'>
                      {jobStage?.name}{' '}
                      <strong style={{ fontSize: '18px' }}>
                        {
                          applications?.filter(
                            (application) =>
                              application?.job_stage === jobStage?.id
                          )?.length
                        }
                      </strong>
                    </CardHeader>
                    <CardBody>
                      {applications
                        ?.filter(
                          (application) =>
                            application?.job_stage === jobStage?.id
                        )
                        ?.map((el, index) => (
                          <Draggable
                            draggableId={el?.id.toString()}
                            index={index}
                            key={el?.id}
                          >
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                className='mb-1'
                              >
                                <Card
                                  onClick={() => {
                                    history.push(
                                      `/job-application?application=${el.id}`
                                    )
                                    setShowModal(true)
                                  }}
                                >
                                  <CardBody className='d-flex justify-content-between'>
                                    <span className='title'>
                                      {el?.job_title}
                                    </span>
                                    <span>{el?.applicant_name}</span>
                                  </CardBody>
                                </Card>
                              </div>
                            )}
                          </Draggable>
                        ))}
                      {provided.placeholder}
                    </CardBody>
                  </Card>
                </div>
              )}
            </Droppable>
          ))}
        </div>
      </DragDropContext>
      {showCreateInterviewModal && (
        <CreateInterviewModal
          showModal={showCreateInterviewModal}
          setShowModal={setShowCreateInterviewModal}
        />
      )}
      {showOnboardingModal && (
        <AddToJobOnboard
          showModal={showOnboardingModal}
          setShowModal={setShowOnboardingModal}
        />
      )}
      {showModal && (
        <Modal
          style={{
            width: '95%',
            minWidth: '95%',
          }}
          isOpen={showModal}
          toggle={() => setShowModal(false)}
          centered
          scrollable
        >
          <ModalHeader
            className='border-bottom'
            toggle={() => setShowModal(false)}
          >
            View Job Application
          </ModalHeader>
          <ModalBody
            className='scrollbar w-100 h-100'
            style={{ height: '90vh', minHeight: '90vh' }}
          >
            <ApplicationDetails onDeleteFn={() => setShowModal(false)} />
          </ModalBody>
        </Modal>
      )}
    </>
  )
}

export default JobApplications
